export enum ToggleButtonsColor {
  LIGHT = 'light',
  DARK = 'dark',
  TRANSPARENT = 'transparent',
}

export type ToggleButtonsIconName = 'ui-close' | 'ui-tick';

interface ValueToggleOption {
  value: string;
  option: string;
}

interface IconToggleOption {
  icon: ToggleButtonsIconName;
  option: string;
}

export type ToggleOption = ValueToggleOption | IconToggleOption;
